import React, {useEffect, useState} from "react";
import {useAlpineStore} from "@arctheme-hooks/useAlpineStore";

export const ModelViewToggle = ({ settings, items, show_header }) => {
    const store: any = useAlpineStore('modelview');

    const [modelView, setModelView] = useState(false);

    useEffect(() => {
        const handleModelViewToggle = (event) => {
            setModelView(event.detail.isModelView);
        };

        window.addEventListener("modelview-toggled", handleModelViewToggle);

        return () => {
            window.removeEventListener("modelview-toggled", handleModelViewToggle);
        };
    }, []);

    const handleToggleChange = (isChecked) => {
        console.log("Toggle is now:", isChecked);
        window.dispatchEvent(new CustomEvent('modelview-toggle', {
            detail: { isModelView: isChecked }
        }));
    };

    return (
        <div className={`flex gap-[20px]`}>
            <div className={`h5 modelview-toggle ${!modelView && 'text-[#C0C0C0]'} cursor-pointer`} onClick={() => handleToggleChange(true)}>
                PRODUCT
            </div>
            <div className={`h5 modelview-toggle active ${modelView && 'text-[#C0C0C0]'} cursor-pointer`} onClick={() => handleToggleChange(false)}>
                OUTFIT
            </div>
        </div>
    );
};

export default ModelViewToggle;
